import qs from 'query-string';
import { get, post, put, patch, del } from './baseApi';

export const FarmLotApi = {
    fetch: (query, options) => get(`/farms/lots?${qs.stringify(query)}`, options),
    fetchById: (id) => get(`/farms/lots/${id}`),
    create: (data) => post('/farms/lots', data),
    update: (id, data) => put(`/farms/lots/${id}`, data),
    patch: (id, data) => patch(`/farms/lots/${id}`, data),
    delete: (id) => del(`/farms/lots/${id}`),
};
